module.exports = __webpack_public_path__ + "static/media/why-choose-us.0740d5ec.jpg";